import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../../axios";
import "dropify/dist/css/dropify.min.css";
import "dropify/dist/js/dropify.min.js";
import $ from "jquery";

const AddTestimonial = () => {
  const { id } = useParams();
  const isEditing = !!id;
  const navigate = useNavigate(); // Add useNavigate hook

  const [name, setName] = useState("");
  const [designation, setDesignation] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef();

  // useEffect(() => {
  //     if (isEditing) {
  //         axios.get(`/testimonials/${id}`)
  //             .then(res => {
  //                 const data = res.data;
  //                 setName(data.name);
  //                 setDesignation(data.designation);
  //                 setDescription(data.description || '');
  //                 setImagePreview(data.image_url); // assuming you return image_url in API
  //             })
  //             .catch(err => {
  //                 console.error('Error fetching testimonial:', err);
  //                 alert("Could not load testimonial data");
  //             });
  //     }
  // }, [id]);

  useEffect(() => {
    if (isEditing) {
      axios
        .get(`/testimonials/${id}`)
        .then((res) => {
          const data = res.data;

          // ✅ Log all relevant testimonial data for frontend integration
          // console.log("Fetched testimonial data:", {
          //   id: data.id,
          //   name: data.name,
          //   designation: data.designation,
          //   description: data.description,
          //   image_url: data.image_url,
          // });

          setName(data.name);
          setDesignation(data.designation);
          setDescription(data.description || "");
          setImagePreview(data.image_url); // For Dropify preview
        })
        .catch((err) => {
          console.error("Error fetching testimonial:", err);
          alert("Could not load testimonial data");
        });
    }
  }, [id, isEditing]);

  useEffect(() => {
    if (isEditing && imagePreview) {
      const $input = $(fileInputRef.current);

      const drEvent = $input.data("dropify");
      if (drEvent) drEvent.destroy();

      // Must set attr BEFORE dropify is initialized
      $input.attr("data-default-file", imagePreview);

      // Wait for DOM to apply attributes before initializing
      setTimeout(() => {
        $input.dropify();
        // console.log('Dropify initialized with imagePreview');
      }, 100);
    }
  }, [isEditing, imagePreview]);

  // ✅ For ADD mode (no image)
  useEffect(() => {
    if (!isEditing) {
      const $input = $(fileInputRef.current);

      const drEvent = $input.data("dropify");
      if (drEvent) drEvent.destroy();

      $input.removeAttr("data-default-file");

      setTimeout(() => {
        $input.dropify();
        // console.log('Dropify initialized for add mode');
      }, 100);
    }
  }, [isEditing]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !designation) {
      alert("Name and Designation are required");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("designation", designation);
    formData.append("description", description);
    if (image) formData.append("image", image);

    const request = isEditing
      ? axios.post(`/testimonials/${id}?_method=PUT`, formData)
      : axios.post("/testimonials", formData);

    request
      .then(() => {
        alert(isEditing ? "Testimonial updated!" : "Testimonial added!");
        // window.location.href = "/admin/testimonialList";
        navigate("/admin/testimonialList");
      })
      .catch((err) => {
        console.error("Error saving testimonial:", err.response?.data);
        alert("Operation failed");
      });
  };

  return (
    <div className="main-content">
      <Link to="/admin/testimonialList" className="text-decoration-none">
        <button className="btn text-black mb-3 border-0">
          <h5>
            ← <span className="ms-2">Back to Testimonial List</span>
          </h5>
        </button>
      </Link>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row gap-lg-5">
          <div className="mb-3 col-5">
            <label className="form-label">
              Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="mb-3 col-5">
            <label className="form-label">
              Designation <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter designation"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="mb-3 col-5">
          <label className="form-label">
            Description <span className="text-danger">*</span>
          </label>
          <textarea
            className="form-control"
            rows="3"
            placeholder="Enter description"
            required
            value={description}
            onChange={(e) => setDescription(e.target.value)}></textarea>
        </div>

        <div className="mb-3 col-5">
          <label className="form-label">Add Image</label>
          <input
            type="file"
            ref={fileInputRef}
            className="form-control dropify"
            onChange={handleImageChange}
            accept="image/*"
          />
        </div>

        <div className="text-end">
          <button
            type="submit"
            className="btn gold-add-btn py-2 px-4 w-auto rounded-0 text-white">
            {isEditing ? "Update" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddTestimonial;
